<div class="baseline">
  <h1>{{'RESULTS.SECTIONS.BASELINE_FINANCIAL_GENERAL' | anessaTranslation: trigger}}</h1>
  <!--START SELECTION BOXES-->
  <div class="row fl">
    <!-- Category Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-financial-general-category_select"
          [(value)]="selectedCategory"
          placeholder="{{'RESULTS.GENERAL.SET_CATEGORY' | anessaTranslation: trigger}}"
          disableOptionCentering
          (valueChange)="setDisplayData(); setDefaultGraphData()"
          panelClass="anessa-dropdown-panel">
          <mat-option
            *ngFor="let opt of categories"
            [value]="opt">{{ opt.translationId | anessaTranslation: trigger }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Currency Select -->
    <div class="fl-item" *ngIf="currencyUnitsLoaded">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-financial-general-currency_select"
          [(value)]="selectedCurrency"
          placeholder="{{'RESULTS.GENERAL.SET_CURRENCY' | anessaTranslation: trigger}}"
          disableOptionCentering
          (valueChange)="setDisplayData(); setDefaultGraphData()"
          panelClass="anessa-dropdown-panel">
          <mat-option
            *ngFor="let opt of currencyUnits"
            [value]="opt">{{ opt.translationId | anessaTranslation: trigger}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <!--END SELECTION BOXES-->

  <div class="fl" *ngIf="displayGraph || displayTable || overviewGraphData.length > 0">
    <p>{{'RESULTS.GENERAL.EXCHANGE_RATES_FROM' | anessaTranslation: trigger}} <i>{{ exchangeRateDate }}</i></p>
  </div>

  <div *ngIf="overviewGraphData && selectedCategory && selectedCategory.name === 'overview'"
       class="default-results-container">
    <div *ngFor="let item of overviewGraphData"
         class="default-graph-container">
        <h3 class="center header-spacer">{{ item.translationId | anessaTranslation: trigger }}</h3>
        <app-graph-selector
          [graphType]="'piechart'"
          [graphData]="item.graphData"
          [yAxisLabel]="currencyLabel"
          [hideSaveButtons]="true"
          [view]="[600, 400]"
          [plotlyLegend]="legend"
        ></app-graph-selector>
      </div>
  </div>

  <!-- GRAPH -->
  <div class="fl" *ngIf="displayGraph">
    <div class="fl-item">
      <app-graph-selector
        [graphType]="graphType"
        [graphData]="graphData"
        [yAxisLabel]="currencyLabel"
        [xAxisLabel]="periodLabel"
      ></app-graph-selector>
    </div>
  </div>

  <!-- TABLE  -->
  <div class="fl" *ngIf="displayTable">
    <div class="fl-item">
      <app-result-table
        [tableData]="tableData"
        [tableHeaders]="tableHeaders"
      ></app-result-table>
    </div>
  </div>
</div>
